import { useSearchParams } from 'react-router-dom';

import { AuthEmail } from 'types';

export const useAuthFlowParams = (): {
  state: string | null;
  redirectUrl: string | null;
  searchParams: URLSearchParams;
  authMode: AuthEmail['authMode'];
  authFlowParams: {
    state?: string;
    redirect_url?: string;
    authMode?: AuthEmail['authMode'];
  };
} => {
  const [searchParams] = useSearchParams();

  const authMode: AuthEmail['authMode'] =
    searchParams.get('authMode') === 'code' ? 'code' : undefined;
  const state = searchParams.get('state');
  const redirectUrl = searchParams.get('redirect_url');

  const authFlowParams = {
    ...(authMode ? { authMode } : {}),
    ...(state ? { state } : {}),
    ...(redirectUrl ? { redirect_url: redirectUrl } : {}),
  };

  return { state, authMode, redirectUrl, searchParams, authFlowParams };
};
